import React from "react";
import { campaignLabel } from "../../Dashboard/constants/labels";
import styles from "../styles/campaignNotifications.module.scss";
import CampaignCopyCell from "./CampaignCopyCell";
import CampaignRowActions from "./CampaignRowActions";
import CampaignSendCounts from "./CampaignSendCounts";

const formatCategory = (campaign) =>
  campaign?.notification_detail?.category || campaign?.trigger_type || "—";

export default function CampaignListTable({
  campaigns = [],
  onEdit,
  onUsers,
}) {
  if (!campaigns.length) {
    return <div className={styles.emptyState}>No campaigns found.</div>;
  }

  return (
    <div className={styles.tableWrap}>
      <table className={styles.dataTable}>
        <thead>
          <tr>
            <th>Campaign</th>
            <th className={styles.centerCell}>Category</th>
            <th>Notification copy</th>
            <th className={styles.centerCell}>Sends</th>
            <th className={styles.centerCell}>Status</th>
            <th className={styles.centerCell}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {campaigns.map((campaign) => {
            const detail = campaign.notification_detail || {};
            const inactive = Number(campaign.is_active) === 0;
            const category = formatCategory(campaign);

            return (
              <tr
                key={campaign.slug}
                className={inactive ? styles.mutedRow : undefined}
              >
                <td>
                  <div className={styles.campaignName}>
                    {campaignLabel(campaign.slug, campaign.name)}
                  </div>
                  {campaign.slug ? (
                    <span className={styles.campaignSlug}>{campaign.slug}</span>
                  ) : null}
                </td>
                <td className={styles.centerCell}>
                  <span className={styles.categoryChip}>
                    {String(category).replace(/_/g, " ")}
                  </span>
                </td>
                <td>
                  <CampaignCopyCell
                    title={detail.title}
                    message={detail.message}
                  />
                </td>
                <td className={styles.centerCell}>
                  <CampaignSendCounts sendCounts={campaign.send_counts} />
                </td>
                <td className={styles.centerCell}>
                  <span
                    className={`${styles.badge} ${
                      inactive ? styles.badgeSkipped : styles.badgeSent
                    }`}
                  >
                    {inactive ? "Inactive" : "Active"}
                  </span>
                </td>
                <td className={styles.centerCell}>
                  <CampaignRowActions
                    canEdit={Boolean(detail.slug)}
                    onEdit={() => onEdit(campaign)}
                    onUsers={() => onUsers(campaign)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
